<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34375 13C2.34375 7.39086 6.89086 2.84375 12.5 2.84375C18.1091 2.84375 22.6562 7.39086 22.6562 13C22.6562 18.6091 18.1091 23.1562 12.5 23.1562C6.89086 23.1562 2.34375 18.6091 2.34375 13ZM16.9523 11.9756C17.7559 12.4221 17.756 13.578 16.9523 14.0244L11.116 17.2668C10.3349 17.7008 9.375 17.136 9.375 16.2424V9.75767C9.375 8.86413 10.3349 8.29932 11.116 8.73326L16.9523 11.9756Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPlayCircle',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>